import { Component, OnInit } from '@angular/core';
import { Payee, AccessToken } from '../shared/sdk/models';
import { PayeeApi } from '../shared/sdk/services';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalEventsManager } from '../events-manager.component'

@Component({
  selector: 'login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css']
})
export class LoginComponent implements OnInit {
  user: Payee = new Payee();
  returnUrl:string;
  constructor(
    private route: ActivatedRoute,
    private userApi: PayeeApi,
    private router: Router,
    private eventsManager: GlobalEventsManager
  ) { }

  ngOnInit() { 
    window.scroll(0, 0);
    if(this.userApi.isAuthenticated()){
      this.router.navigate(['/dashboard']);
    }

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.eventsManager.loaded(true)
  }

  login(): void {
    this.userApi.login(this.user).subscribe(
      res => { 
        this.eventsManager.showNavBar(true);
        if (this.returnUrl == '/') {
          this.userApi.countSubmissions(this.userApi.getCurrentId(), {'isSubmitted': true}).subscribe(
            (res) => {
              if (res.count > 0) {
                this.router.navigate(['/dashboard']);
              } else {
                this.router.navigate(['/chooseBusiness']);
              }
            },
            () => this.router.navigate(['/'])
          );
        }else
          this.router.navigateByUrl(this.returnUrl);
        
      }, 
      err => {
        // this.eventsManager.showPopUp("A reset email has been successfully sent to .");
        // this.invalidate();
        console.log("LoginComponent userApi.login err")
        console.log(err);
      //   this.eventsManager.showPopUp("Once application submitted, it will be valid for 3 months. \n <br/> \
      // It is mandatory to open a Business Current Account to avoid your application being terminated automatically. \n <br/> \
      // Once you have your Business Current Account number, please update it into the portal.");
        if (err.message && (err.code == 'LOGIN_FAILED')) {
          console.log('LOGIN_FAILED message');
          this.eventsManager.showPopUp(err.message);
        }
        else if (err.code == 'LOGIN_FAILED') {
          console.log('LOGIN_FAILED');
          this.eventsManager.showPopUp("Oops. Invalid credentials.");
        } else if (err.code == 'LOGIN_FAILED_EMAIL_NOT_VERIFIED') {
          console.log('LOGIN_FAILED_EMAIL_NOT_VERIFIED');
          this.eventsManager.showPopUp("Please verify your e-mail before logging in.");
        } else if (err.code == 'ACCESS_BLOCKED') {
          this.eventsManager.showPopUp("Your access has been blocked. Please contact maybank2upay@maybank.com regarding on this matter.");
        }
      }
    );
  }

}